/**
 * Benefits/Why Choose Us data for Home page
 */
import SpeedIcon from "@mui/icons-material/Speed";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CodeIcon from "@mui/icons-material/Code";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

export const getBenefits = (t) => [
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: t("home.benefits.performance.title"),
    description: t("home.benefits.performance.description"),
  },
  {
    icon: <TaskAltIcon sx={{ fontSize: 40 }} />,
    title: t("home.benefits.security.title"),
    description: t("home.benefits.security.description"),
  },
  {
    icon: <CodeIcon sx={{ fontSize: 40 }} />,
    title: t("home.benefits.modern.title"),
    description: t("home.benefits.modern.description"),
  },
  {
    icon: <AutoAwesomeIcon sx={{ fontSize: 40 }} />,
    title: t("home.benefits.ai.title"),
    description: t("home.benefits.ai.description"),
  },
  {
    icon: <SupportAgentIcon sx={{ fontSize: 40 }} />,
    title: t("home.benefits.support.title"),
    description: t("home.benefits.support.description"),
  },
];
